export const shortFullName = (fullName: string): string => {
    const names = fullName?.split(' ') ?? 0

    if (names.length === 3)
        return `${names[0]} ${names[1][0]}.${names[2][0]}.`
    else
        return fullName
}